/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Applicants_Bulk_Reject_ButtonInputs */

const en_applicants_bulk_reject_button = /** @type {(inputs: Applicants_Bulk_Reject_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reject`)
};

const de_applicants_bulk_reject_button = /** @type {(inputs: Applicants_Bulk_Reject_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ablehnen`)
};

/**
* | output |
* | --- |
* | "Reject" |
*
* @param {Applicants_Bulk_Reject_ButtonInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const applicants_bulk_reject_button = /** @type {((inputs?: Applicants_Bulk_Reject_ButtonInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Applicants_Bulk_Reject_ButtonInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_applicants_bulk_reject_button(inputs)
	return en_applicants_bulk_reject_button(inputs)
});